import React, { useState } from "react";
import styled from "styled-components";

import { delay } from "@examspark/common";
import { Button, VSpace, Text } from "@examspark/common-ui";
import { ParsedClassroom } from "@examspark/types";

import { getStudentDomain } from "../../../..";

import { AssignActivityModalProps } from "./AssignActivityGoogleClassroom";

const CodeSpan = styled.a`
  border: solid 1px #ddd;
  font-family: input-mono, monospace;
  padding: 0.3rem;
  color: #006699;
  border-radius: 0.3rem;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #006699;
    border: solid 1px #006699;
    color: #fff;
  }
`;

const Styled = styled.div`
  padding: 0.5rem;

  h2 {
    margin-top: 0;
    font-weight: 500;
    color: #333;
    margin-bottom: 1rem;
  }
  h3 {
    text-transform: uppercase;
    font-weight: normal;
    color: #555;
    font-size: 1.2rem;
  }
`;

const AssignActivityExamSpark = (
  props: AssignActivityModalProps & { classroom: ParsedClassroom },
) => {
  const [isPublishing, setIsPublishing] = useState(false);
  const studentDomain = getStudentDomain();

  return (
    <Styled>
      <VSpace size="2rem">
        <Text.Body>
          Students will be able to complete this assignment at{" "}
          <CodeSpan href={studentDomain} target="_blank">
            {studentDomain.replace("https://", "")}
          </CodeSpan>{" "}
          using a 6-character access code.
        </Text.Body>
        <div>
          <Button
            title="Publish to ExamSpark"
            color="create"
            disabled={isPublishing}
            isLoading={isPublishing}
            onClick={async () => {
              setIsPublishing(true);
              // delay is gratuitous
              await delay(1000);
              setIsPublishing(false);
              props.onPublish?.();
            }}
          >
            Publish To ExamSpark
          </Button>
        </div>
      </VSpace>
    </Styled>
  );
};

export default AssignActivityExamSpark;
